import Lottie from "lottie-react";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import animation from "../../../assets/animations/messageAnimation.json"
import Button from "../../../components/button";
import add from "../../../assets/icons/whiteAddCampaignIcon.svg";
import arrow from "../../../assets/icons/arrowOutlined.svg";
import { Link } from "react-router-dom";

const AllUserCampaign = ({setPageTitle, campaignID}) => {


  const [filter, setFilter] = useState("All");
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    setPageTitle("userCampaign");
    document.title = "My campaigns - Mosquepay";
  }, [setPageTitle]);

  // When filter changes, reset the page to 1
  useEffect(() => {
    setCurrentPage(1);
  }, [filter]);

  const userSessionData = useSelector((state) => state.user.userSession);
  const campaigns = userSessionData.user_campaign_details;

  const filteredCampaigns = campaigns.filter((row) => {
    if (filter === "All") return true;
    if (filter === "Active" && row.admin_status === "0") return true;
    if (filter === "Completed" && row.admin_status === "4") return true;
    if (filter === "Pending" && row.admin_status === "1") return true;
    return false;
  });

  const campaignsPerPage = 5;
  const totalPages = Math.ceil(filteredCampaigns.length / campaignsPerPage);

  const startIndex = (currentPage - 1) * campaignsPerPage;
  const currentCampaigns = filteredCampaigns.slice(
    startIndex,
    startIndex + campaignsPerPage
  );

  // Handle next page
  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  // Handle previous page
  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  return (
    <div>
      <div className="grid mb-4">
        <span className="font-semibold">Your campaigns.</span>
        <span className="text-secondary text-sm">Manage your campaigns</span>
      </div>

      {filteredCampaigns.length === 0 ? (
        <div className="flex justify-center">
          <div className="md:w-1/2 text-center grid gap-6">
            <div className="flex justify-center">
              <Lottie animationData={animation} loop={false} className="w-20" />
            </div>
            <div className="grid gap-1">
              <p className="font-medium">You haven’t created a campaign yet.</p>
              <p className="text-secondary">
                Create your first campaign and start making a difference today!
                Whether you’re raising funds for personal causes or supporting
                others, your impact starts here.
              </p>
            </div>
            <div className="flex justify-center">
              <Button
                buttonText={"Create a campaign"}
                buttonRole={"link"}
                destination={"/dashboard/start-a-campaign"}
                otherStyles={"bg-black text-white w-fit"}
                icon={add}
              />
            </div>
          </div>
        </div>
      ) : (
        <div>
          <div className=" overflow-x-auto whitespace-nowrap mb-6">
            <div className="flex text-sm bg-white border rounded py-3 w-fit divide-x">
              <span
                className={`px-4 cursor-pointer font-semibold ${
                  filter === "All" ? "text-brandGreen" : "text-black"
                }`}
                onClick={() => setFilter("All")}
              >
                All campaigns
              </span>
              <span
                className={`px-4 cursor-pointer font-semibold ${
                  filter === "Active" ? "text-brandGreen" : "text-black"
                }`}
                onClick={() => setFilter("Active")}
              >
                Active
              </span>
              <span
                className={`px-4 cursor-pointer font-semibold ${
                  filter === "Completed" ? "text-brandGreen" : "text-black"
                }`}
                onClick={() => setFilter("Completed")}
              >
                Completed
              </span>
              <span
                className={`px-4 cursor-pointer font-semibold ${
                  filter === "Pending" ? "text-brandGreen" : "text-black"
                }`}
                onClick={() => setFilter("Pending")}
              >
                Pending
              </span>
            </div>
          </div>
          <div className="grid grid-cols-1 whitespace-nowrap overflow-x-auto border border-lightPrimary rounded-md mt-6">
            <table class="w-full text-sm text-left bg-white">
              <thead class="bg-secondaryBackground border-b border-lightPrimary">
                <tr className="">
                  <th
                    scope="col"
                    class="ps-6 pe-2 py-[18px] bg-secondaryBackground whitespace-nowrap sticky left-0 z-10"
                  >
                    No.
                  </th>
                  <th scope="col" class="pe-6 py-[18px] whitespace-nowrap">
                    Campaign title
                  </th>
                  <th scope="col" class="px-6 py-[18px] whitespace-nowrap">
                    Campaign goal
                  </th>
                  <th scope="col" class="px-6 py-[18px] whitespace-nowrap">
                    Amount raised
                  </th>
                  <th scope="col" class="px-6 py-[18px] whitespace-nowrap">
                    Donations
                  </th>
                  <th scope="col" class="px-6 py-[18px] whitespace-nowrap">
                    Status
                  </th>
                </tr>
              </thead>
              <tbody>
                {currentCampaigns.map((row, index) => (
                  <tr key={index} className="hover:bg-[#c4c4c416] transition duration-500 relative">
                    <td className="text-start py-4 ps-6 pe-2 sticky left-0 bg-white z-10">
                      {startIndex + index + 1}.
                    </td>
                    <td className="text-start py-4 pe-6 ps-1 max-w-60 md:max-w-80 truncate">
                      {row.title}
                    </td>
                    <td className="text-start py-4 ps-6"> {row.amount}</td>
                    <td className="text-start py-4 ps-6">
                      {row.amount_raise}{" "}
                    </td>
                    <td className="text-start py-4 ps-6">{row.txn_count}</td>
                    <td
                      className={`text-start py-4 px-6 font-semibold ${
                        row.admin_status === "4"
                          ? "text-brandGreen"
                          : row.admin_status === "0"
                          ? "text-green-500"
                          : row.admin_status === "1"
                          ? "text-[#FFA500]"
                          : "text-black"
                      }`}
                    >
                      {row.admin_status === "4"
                        ? "Completed"
                        : row.admin_status === "0"
                        ? "Active"
                        : row.admin_status === "1"
                        ? "Pending"
                        : ""}
                    </td>
                    <Link to={`/dashboard/user-campaign-detail/${row.CampaignID}`} className={`${row.admin_status === "1" ? "hidden" : "absolute w-full h-full left-0 right-0"}`}>
                    </Link>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="mt-6 flex items-center gap-6">
            <button
              className={`${
                currentPage === 1 ? "opacity-50" : "opacity-100 cursor-pointer"
              } border rounded-md p-2`}
              onClick={handlePreviousPage}
              disabled={currentPage === 1}
            >
              <img src={arrow} alt="" className="h-5 rotate-180" />
            </button>
            <span className="text-sm">
              Page <span className="font-bold">{currentPage}</span> of{" "}
              <span className="font-bold">{totalPages}</span>
            </span>
            <button
              className={`${
                currentPage === totalPages
                  ? "opacity-50"
                  : "opacity-100 cursor-pointer"
              } border rounded-md p-2`}
              onClick={handleNextPage}
              disabled={currentPage === totalPages}
            >
              <img src={arrow} alt="" className="h-5" />
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
 
export default AllUserCampaign;